import React, { ReactElement } from 'react';
import { Route, RouteProps, Routes } from 'react-router-dom';
import headers from '../../routes/headerRoutes';

const HeaderRoutes = (): ReactElement => {
	return (
		<Routes>
			{headers.map((page: RouteProps): ReactElement => (
				<Route key={page.path} {...page} />
			))}
		</Routes>
	);
};

export default HeaderRoutes;
